import React from "react";
import tw, { css } from "twin.macro";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import people from "../../images/people.png";

function SupportSection() {
  return (
    <React.Fragment>
      <div tw="bg-primary">
        <div tw="container mx-auto">
          <div tw="flex flex-col lg:justify-start justify-center px-4">
            <div>
              <p tw="md:text-5xl text-2xl lg:font-bold font-bold lg:pl-32 md:pl-20 pl-8 md:pt-20 pt-10">
                thanks.
              </p>
              &nbsp;
              <p tw="md:text-5xl text-2xl lg:font-bold font-bold lg:pl-32 md:pl-20 pl-8">
                We really appreciate it.
              </p>
            </div>
            <img
              src={people}
              alt="process points"
              tw="relative lg:bottom-32 md:bottom-24"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SupportSection;
